import React, { useEffect } from "react";
import * as R from "ramda";
import { useNavigate } from "react-router-dom-v5-compat";

import { FullScreenLoader } from "components/Loader";
import { useAnswerContext } from "contexts/answerContext";
import { getFirstPage } from "queries/projects";
import { useRequirement } from "queries/requirements";
import { getGuideType, getRequirementIDs, isInProgress } from "reducers/projects";

const useProjectResumePath = () => {
  const { record: project } = useAnswerContext();
  const { id: projectID } = project;
  const directRequirementID = R.head(getRequirementIDs(project));
  const { data: directRequirement } = useRequirement(directRequirementID, {
    enabled: !!directRequirementID,
  });

  if (!isInProgress(project)) {
    // this project is post scoping
    if (Object.keys(project.requirement_applications).length === 1) {
      const requirementID = Object.values(project.requirement_applications)[0].requirement_id;

      return `/projects/${projectID}/application/${requirementID}`;
    }
    return `/projects/${projectID}/apply`;
  }

  if (getGuideType(project) === "direct_application") {
    return `/projects/${projectID}/direct/${directRequirement?.slug}`;
  }

  const nextPage = getFirstPage(project);
  return `/projects/${projectID}/guide/${nextPage}`;
};

const ResumeProjectRedirect = () => {
  const next = useProjectResumePath();

  const navigate = useNavigate();
  useEffect(() => {
    navigate(next, { replace: true });
  }, [navigate, next]);

  return <FullScreenLoader label="ResumeProjectRedirect" />;
};
export default ResumeProjectRedirect;
